export default __webpack_public_path__ + "static/media/Arm-bands of the Bloodhunter (nm).c56b3c71.jpg";